import React, { Component } from 'react';

class Faq extends Component {
    render() {
        return <div>
            <h1>Frequently Asked Questions</h1>

            <p>
            Before contacting us with questions please make sure your question isn't answered below.
            </p>
    
            <h2>General</h2>  
            Q. 1.0 &nbsp; <a href="#1_0">What is NslMail?</a><br/>
            Q. 1.1 &nbsp; <a href="#1_1">What isn't NslMail?</a><br/>            
            Q. 1.2 &nbsp; <a href="#1_2">Is it free?</a><br/>
            Q. 1.3 &nbsp; <a href="#1_3">Why another spam tool</a><br/>
            Q. 1.4 &nbsp; <a href="#1_4">But I already use a nice email program</a><br/>
            
            <h2>Email</h2>
            Q. 2.0 &nbsp; <a href="#2_0">Why can't I specify my own email alias?</a><br/>
            Q. 2.1 &nbsp; <a href="#2_1">Email's are showing up garbled</a><br/>
        
            <br/><br/>
    
            <h2>General</h2>
            <a name="1_0" href="#top"><h3>A. 1.0 &nbsp;&nbsp; What is NslMail?</h3><br/></a>
            NslMail is an alternative method for tracking spam and keeping control of your inbox.
            <a href="#top"><p align="right">Return to top&nbsp;&nbsp;</p></a>
                  
            <a name="1_1" href="#top"><h3>A. 1.1 &nbsp;&nbsp; What isn't NslMail?</h3><br/></a>
            NslMail is not an email hosting service.  You must already have a valid email account to use with this service.
            <a href="#top"><p align="right">Return to top&nbsp;&nbsp;</p></a>

            <a name="1_2" href="#top"><h3>A. 1.2 &nbsp;&nbsp; Is it free?</h3><br/></a>
            This service will remain free during the beta period, after which, there will most likely be a free and a pro version.
            <a href="#top"><p align="right">Return to top&nbsp;&nbsp;</p></a>

            <a name="1_3" href="#top"><h3>A. 1.3 &nbsp;&nbsp; Why another spam tool</h3><br/></a>            
            Other spam tools work by either analyzing message content or by referring to a master blacklist.  NslMail takes a different approach.  A unique email address is used for each email source, thereby any message not from that source is considered spam.
            <a href="#top"><p align="right">Return to top&nbsp;&nbsp;</p></a>
          
            <a name="1_4" href="#top"><h3>A. 1.4 &nbsp;&nbsp; But I already use a nice email program</h3><br/></a>            
            Thats great!  You can most likely use it with NslMail.  We have tested compatibility with Thunderbird, Outlook, Outlook Express, Hotmail, Gmail & Yahoo Mail.
            <a href="#top"><p align="right">Return to top&nbsp;&nbsp;</p></a>

            <h2>Email</h2>
            <a name="2_0" href="#top"><h3>A. 2.0 &nbsp;&nbsp; Why can't I specify my own email alias?</h3><br/></a>
            For NslMail to be effective, it relies on your aliases to be cryptic enough that spammers can't guess it through a brute force attack.  Currently this is achieved by not allowing users to specify their own alias.  This may change in the future.
            <a href="#top"><p align="right">Return to top&nbsp;&nbsp;</p></a>

            <a name="2_1" href="#top"><h3>A. 2.1 &nbsp;&nbsp; Email's are showing up garbled</h3><br/></a>
            Please contact us and tell us what email client / service you are using.  A copy of the message is question wouldn't hurt either.
            <a href="#top"><p align="right">Return to top&nbsp;&nbsp;</p></a>
              
        </div>
    }
}

export default Faq;